import React from "react";

const LoadingSpinner: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-50 via-white to-blue-50">
      <div className="relative flex flex-col items-center gap-6 p-8 rounded-2xl backdrop-blur-xl bg-white/70 shadow-xl">
        
        {/* Outer glow */}
        <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-blue-500/20 to-indigo-500/20 blur-xl"></div>

        {/* Spinner */}
        <div className="relative">
          <div className="h-14 w-14 rounded-full border-4 border-transparent border-t-blue-600 border-r-indigo-500 animate-spin"></div>
          <div className="absolute inset-0 h-14 w-14 rounded-full border-4 border-blue-200 animate-ping"></div>
        </div>

        {/* Text */}
        <div className="flex flex-col items-center gap-1">
          <p className="text-sm font-medium text-gray-800 tracking-wide">
            Loading
          </p>
          <span className="text-xs text-gray-500 animate-pulse">
            Please wait a moment
          </span>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
